import { c as _c } from "react/compiler-runtime";
import { FeatherHelpCircle } from '@subframe/core';
import type { IdentificacaoSentenca, OrientacaoDuvidaSentenca } from '../../../types/sentencaArbitral.types';
import { TEXTOS_SENTENCA_ARBITRAL } from './secoesSentencaArbitral';
interface PainelValidadeSentencaProps {
  identificacao: Pick<IdentificacaoSentenca, 'autenticidadeUrl' | 'autenticidadeUrlExibicao'>;
  codigoAutenticacao: string;
}
export function PainelValidadeSentenca(t0) {
  const $ = _c(13);
  const {
    identificacao,
    codigoAutenticacao
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-brand-600 mb-2 text-[16px] font-bold">{TEXTOS_SENTENCA_ARBITRAL.validadeTitulo}</div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== identificacao.autenticidadeUrl || $[2] !== identificacao.autenticidadeUrlExibicao) {
    t2 = <p className="mb-2.5 text-[13.5px] leading-[1.55] text-neutral-700">Utilize o código ao lado em{" "}<a className="text-brand-600 font-bold hover:underline" href={identificacao.autenticidadeUrl} rel="noopener noreferrer" target="_blank">{identificacao.autenticidadeUrlExibicao}</a>{" "}para comprovar a validade deste documento.</p>;
    $[1] = identificacao.autenticidadeUrl;
    $[2] = identificacao.autenticidadeUrlExibicao;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="text-[12.5px] leading-[1.55] text-neutral-500">{TEXTOS_SENTENCA_ARBITRAL.validadeEfeitos}</p>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <div className="flex-1">{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mb-3 text-[11px] font-bold tracking-[1.2px] text-neutral-500 uppercase">Código de Autenticação</div>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== codigoAutenticacao) {
    t6 = <div className="rounded-[12px] bg-neutral-100 px-6 py-[22px] sm:w-[280px] sm:flex-none sm:self-start">{t5}<div className="text-brand-600 text-[18px] font-bold tracking-[0.5px]">{codigoAutenticacao}</div></div>;
    $[8] = codigoAutenticacao;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <div className="px-[37px] pt-[30px] pb-[30px]"><div className="border-brand-100 flex flex-col gap-6 rounded-[14px] border border-solid px-7 py-[22px] sm:flex-row">{t4}{t6}</div></div>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
interface AvisoDuvidaSentencaProps {
  orientacao: OrientacaoDuvidaSentenca;
}
export function AvisoDuvidaSentenca(t0) {
  const $ = _c(8);
  const {
    orientacao
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FeatherHelpCircle className="text-brand-600 mt-[2px] h-[18px] w-[18px] flex-none" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== orientacao.titulo) {
    t2 = <div className="text-brand-600 mb-[2px] text-[14px] font-bold">{orientacao.titulo}</div>;
    $[1] = orientacao.titulo;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== orientacao.texto) {
    t3 = <div className="text-[13.5px] leading-[1.55] text-neutral-700">{orientacao.texto}</div>;
    $[3] = orientacao.texto;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="px-[37px] pb-[26px]"><div className="border-brand-100 bg-brand-50 flex gap-3 rounded-[12px] border border-solid px-[22px] py-[18px]">{t1}<div>{t2}{t3}</div></div></div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}